<template>
    <div class="layout-container table-special">
        <el-tabs type="border-card">
            <el-tab-pane label="资讯模板列表">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label">动态分类</span>
                            <div class="input-condition">
                                <el-select v-model="condition.type_id" placeholder="全部" clearable>
                                    <el-option v-for="item in typeList" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">模板名称</span>
                            <div class="input-condition">
                                <el-input v-model="condition.name" maxlength="30" placeholder="请输入模板名称"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">动态标题</span>
                            <div class="input-condition">
                                <el-input v-model="condition.title" maxlength="30" placeholder="请输入动态标题"></el-input>
                            </div>
                        </div>

                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button @click="resetSearch()">清空条件</el-button>
                        <el-button type="primary" icon="el-icon-plus" v-permission="'operating.house-trend-model-manage.trend-template-list.create'" @click="handleAdd()">新增动态模板</el-button>
                    </div>
                </div>
                <el-table :data="list" style="width: 100%" :highlight-current-row="true" stripe tooltip-effect="dark"
                    ref="multipleTable" v-loading="isLoading" header-cell-class-name="table-back" class="list-table">
                    <el-table-column label="ID" prop="id" width="60px" align="center"></el-table-column>
                    <el-table-column label="动态分类" prop="type_name" align="center" width="200px"></el-table-column>
                    <el-table-column label="模板名称" prop="name" align="center" width="200px"></el-table-column>
                    <el-table-column label="动态标题" prop="title" align="center"></el-table-column>

                    <el-table-column label="添加人" prop="operator" align="center"></el-table-column>
                    <el-table-column label="添加时间" prop="created_at" align="center" width="200px"></el-table-column>
                    <el-table-column label="动态生成数量" prop="create_num" align="center" width="120px"></el-table-column>
                    <el-table-column label="动态生成记录" align="center" width="120px">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="getRecord(scope.row.id)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="350px">
                        <template slot-scope="scope">
                            <a class="scan" v-if="scope.row.url" :href="scope.row.url" target="_blank"
                                style="text-decoration:none;cursor: pointer;">预览</a>
                            <el-button v-permission="'operating.house-trend-model-manage.trend-template-list.edit'" size="mini"
                                @click="openEdit(scope.row.id)">编辑</el-button>
                            <el-button v-permission="'operating.house-trend-model-manage.trend-template-list.generation'"
                                size="mini" @click="createDynamic(scope.row.id)">生成动态</el-button>
                            <el-button v-permission="'operating.house-trend-model-manage.trend-template-list.delete'" size="mini"
                                @click="handleDelete(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"
                        :total="condition.total" :page-size="condition.per_page"
                        @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
        <create-dynamic ref="createDynamic" :callback="initData"></create-dynamic>
        <record-list ref="recordList"></record-list>
    </div>
</template>
<style>
td a:link {
    color: #606266;
}

td a:visited {
    color: #606266;
}
</style>
<script>
import { getSite } from "@/service/site";
import createDynamic from "./component/createDynamic";
import recordList from "./component/recordList";
import {getDynamicModelList,deleteDynamicModel} from '@/service/dynamicModel'

export default {
    name: "List",
    components: {
        createDynamic,
        recordList
    },
    data() {
        return {
            typeList: [{
                id: 1,
                name: "楼盘动态"
            }, {
                id: 2,
                name: "开盘信息"
            }, {
                id: 3,
                name: "交房信息"
            }, {
                id: 4,
                name: "证件信息"
            }],
            list: [],
            condition: {
                type_id: '',
                name: '',
                title: '',
                total: 0,
                per_page: 10,
                page: 1,
            },
            siteAll: [],
            isLoading: false,

        }
    },
    mounted() {
        this.isLoading = true
        this.initData();
        this.getSiteList()
    },
    methods: {
        async initData() {
            this.list=[]
            await getDynamicModelList(this.condition).then((data) => {
                this.condition.total=data.total
                let siteurl = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14);
                let url = "https://cs."+siteurl+'/loupan/dongtai/preview/';
                data.data.forEach((item,index)=>{
                    data.data[index].url =url+item.id+'.html';
                })
                this.list = data.data
            })

            
            //数据请求完毕取消当前页面的loading
            this.isLoading = false
        },
        handleSearch() {
            this.condition.page = 1
            this.isLoading = true
            this.initData();
        },
        resetSearch() {
            this.condition = {
                type_id: '',
                name: '',
                time: '',
                total: 0,
                per_page: 10,
                page: 1,
                status: ''
            }
            this.initData();
        },
        handleAdd() {
            this.$router.push({ path: 'add' });
        },
        openEdit(id) {
            this.$router.push({ path: 'add', query: { id: id } })
        },
        currentChange(index) {
            this.condition.page = index;
            this.initData();
        },
        async getSiteList() {
            await getSite({ owned: 1, agent_status: 0, per_page: 1000 }).then((data) => {
                this.siteAll = data.data;
            });

        },
        handleDelete(id) {
            this.$confirm("请确认是否删除该模板？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                deleteDynamicModel(id)
                .then(() => {
                    this.$message({
                    type: "success",
                    message: "删除成功"
                    });
                    this.initData();
                })
                .catch(err => {
                    this.$message({
                    type: "error",
                    message: err.message || "删除失败"
                    });
                });
            });
        },
        createDynamic(id) {
            this.$refs.createDynamic &&
                (this.$refs.createDynamic.siteList = this.siteAll)
                && this.$refs.createDynamic.open(id)
        },
        getRecord(id) {
            this.$refs.recordList
                && this.$refs.recordList.open(id);
        },
    }
}
</script>

<style >
.list-table {
    /* padding: 0 20px; */
    box-sizing: border-box;
}

.baikeCat .el-select {
    width: 48%;
    float: left;
}

.v-modal {
    z-index: 2000 !important;
}

.el-table .cell a.scan {
    padding: 0px 15px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    margin-right: 10px;
    line-height: 26px;
    display: inline-block;
}

.el-table .cell a.scan:hover {
    color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}

.ellips2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    max-height: 45px;
}
</style>



















